export const arrayCommaJoin = (arr: string[]) => {
  return arr.reduce((acc, s, i) => {
    if (i === arr.length - 1 && arr.length > 1) {
      return acc + ' & ' + s;
    }
    return acc + (i !== 0 ? ', ' : '') + s;
  }, "");
}
export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const zeroPadNum = (baseNum: number, padSize: number) => {
  const numZeroes = padSize - `${baseNum}`.length
  return `${'0'.repeat(numZeroes > 0 ? numZeroes : 0)}${baseNum}`
}
export const random3DigitNumber = () => zeroPadNum(getRandomInt(0, 999), 3)
// doesn't catch negative/decimal numbers from strings!
export const enforceNumberType = (s: any) => {
  if (typeof s === "number") {
    return s
  }
  if (typeof s === "string") {
    const regexpResult = s.match(/^\D*(\d+)/)
    const startingNum = regexpResult ? regexpResult[1] : ""
    return parseInt(startingNum, 10)
  }
  return s
}
export const snakeToCamel = (str: string) => str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
export const snakeToPascal = (str: string) => {
  const camel = snakeToCamel(str);
  return camel.charAt(0).toUpperCase() + camel.slice(1);
}
export const camelToSnake = (str: string) => str
  .replace(/([A-Z])/g, "_$1") // insert underscore before capitals
  .toLowerCase()
  .replace(/^_/, ''); // remove leading underscore if PascalCase
export const kebabToCamel = (str: string) => str.replace(/\-([a-z])/g, (_, letter) => letter.toUpperCase());

export const aiTextNormalizer = (s: string) => s.replace(/\u2013|\u2014|\u2015/g,'-').trim()
